// Builds a unified, newest-first timeline from a list of posts: each post
// is one item, and each repost of a post is its OWN item too (shown with a
// "reposted by" banner), the way a retweet shows up as its own entry in a
// feed rather than being buried inside the original post.
//
// Note: within a page of loaded posts, reposts sort correctly by their own
// timestamp alongside everything else. Across pages, a repost can only
// appear once its *parent post's* page has loaded (since reposts are
// fetched nested under their post, not paginated independently) — a
// reasonable simplification given reposts are relatively infrequent, but
// worth knowing if a very old post gets a fresh repost: the repost won't
// surface as its own recent timeline entry until that old post's page is
// reached.
export function buildFeedTimeline(posts) {
  const items = [];
  posts.forEach((post) => {
    items.push({ key: `post-${post.id}`, post, sortDate: post.createdAt, repostedBy: null });
    (post.reposts || []).forEach((r) => {
      items.push({
        key: `repost-${r.id}`,
        post,
        sortDate: r.createdAt,
        repostedBy: { id: r.user?.id, name: r.user?.name, lastName: r.user?.lastName, comment: r.comment },
      });
    });
  });
  return items.sort((a, b) => new Date(b.sortDate) - new Date(a.sortDate));
}
